// @flow

import { allSites } from './allSites';
import type { Site } from './types';
import { retrieve } from 'putki';

export function currentSite(): Site {
  const sites = allSites();
  const key = retrieve('current_site');

  const site = sites.find(s => s.key === key);
  return site || sites[0];
}
